<template>
  <div>
    <el-header style="background-color: #001938">
    <el-row>
      <el-col :span="3">
        <el-image :src="logo" class="logo-sy" fit="contain"></el-image>
      </el-col>
      <el-col :span="19" id="menuDiv">
        <el-menu class="el-menu-demo"
                 mode="horizontal"
                 @select="handleSelect"
                 :router="true"
                 text-color="#fff"
                 background-color="#001938"
                 active-text-color="rgb(124, 185, 186)"
                 :default-active="active"
        >
          <template v-for="(item,index) in menus">
            <el-submenu v-if="item.children && item.children.length>0" v-bind:key="index" index="" popper-class="sub-menu-sy" :popper-append-to-body="false">
              <template slot="title">
                <span class="menu-text">{{ item.name }}</span>
              </template>
              <el-menu-item  v-for="(subItem, sdx) in item.children" v-bind:key="sdx" :index="subItem.idx" :route="subItem.route"> {{ subItem.name }}
              </el-menu-item>
              <!--              <Menu :data="item.children" />-->
            </el-submenu>
            <el-menu-item  v-else v-bind:key="index" :index="item.idx" :route="item.route" style="padding: 0">
              {{ item.name }}
            </el-menu-item>
          </template>
        </el-menu>
      </el-col>
      <el-col :span="2" class="foot-icon-d">
        <el-popover
            placement="top-start"
            width="200"
            transition="fade-in-linear"
            trigger="hover">
          <div>客户热线：400-012-9558</div>
          <div>加盟热线：400-012-9558</div>
          <i slot="reference" class="el-icon-phone-outline"></i>
        </el-popover>
        <el-popover
            placement="top-start"
            width="265"
            transition="fade-in-linear"
            trigger="hover">
          <div style="float: right">
            <el-image :src="dyQr" style="width: 120px;height: 120px;"></el-image>
            <div class="demonstrations">陌上酒店抖音公众号</div>
          </div>
          <div style="float: right">
            <el-image :src="wxQr" style="width: 120px;height: 120px;"></el-image>
            <div class="demonstration">微信扫码预定酒店<br/><span>关注陌上酒店公众号</span></div>
          </div>
          <i slot="reference" class="el-icon-mobile-phone" style="margin-left: 20px;"></i>
        </el-popover>
      </el-col>
    </el-row>
  </el-header>
    <div class="float-code">
      <el-image :src="wxQr" style="width: 120px;height: 120px;"></el-image>
      <div class="demonstration" style="color: #9f6c2f;font-size: 12px">微信扫码预定酒店</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  props: {
    active: {
      type: String,
      default: '1'
    },
  },
  data() {
    return {
      //logo: require('../assets/images/logo/logo.png'),
      logo: require('../assets/images/logo/logo-01.png'),
      wxQr: require('../assets/images/微信扫码305-305.png'),
      dyQr: require('../assets/images/抖音扫码305-305.png'),
      menus: [
        {name: '首页', idx: '1', route: '/index'},
        //{name: '集团概况', idx: '2', route: '/about'},
        {name: '酒店品牌',
          children:[
            {name: '陌上轻雅', idx: '2-1', route: {path: '/brand', query: {pmark: '2-1'}}},
            {name: '陌上轻居', idx: '2-2', route: {path: '/brand', query: {pmark: '2-2'}}},
            {name: '陌上艺宿', idx: '2-3', route: {path: '/brand', query: {pmark: '2-3'}}},
            {name: '陌上轻奢', idx: '2-4', route: {path: '/brand', query: {pmark: '2-4'}}},
          ]
        },
        {name: '陌上商旅', idx: '4', route: '/msTrader'},
        {name: '合作攻略', idx: '5', route: '/cooperate'},
        {name: '陌上战略', idx: '6', route: '/msStrategy'},
        {name: '联系我们', idx: '7', route: '/contactWe'},
      ]
    }
  },
  methods: {
    handleSelect() {

    }
  },
  components: {
  }
}
</script>

<style scoped>
.logo-sy {
  width: 130px;
  height: 60px;

}
.el-header{
  padding: 0 30px;
}
.el-menu-demo {
  float: right;
}
.foot-icon-d {
  font-size: 30px;
  color: #fff;
  text-align: left;
  line-height: 61px;
}
#menuDiv >>> .el-menu--popup {
  min-width: 96px !important;
}
#menuDiv >>> .el-menu-item {
  min-width: 96px !important;
}
#menuDiv >>> .el-menu--horizontal {
  border-bottom: none;
}
#menuDiv >>> .el-submenu__icon-arrow{
  display: none;

}

#menuDiv >>> .el-submenu__icon-arrow {
  display: none;
}
.float-code {
  position: fixed;
  top: 46%;
  right: 0;
  z-index: 999;
  background: #fff;
  padding: 6px;
}
</style>
